<template lang="pug">
div
  section.u-mt-md
    AppTitle(:title="$t('mantra')")


  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec3')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec3Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec4')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec4Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid.is-tablet-6
      .column.u-mb-sm(v-for="item,idx in $t('sec5Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"ERP",
    "pageDesc":"Run your organization smarter with custom ERP system that is built around your business needs, departments and every day operations.",
    "mantra":"Bring your business in |one place with ERP",
    "sec1Items":{
      "1":{
        "title":"ERP system development",
        "desc":"Tailoring a solution from scratch based on your business requirements. Oulting the modules needed whether human resources system, inventory management or others."
      },
      "2":{
        "title":"ERP customizations",
        "desc":"Building on your current solution, we customize and enhance its features to better suit your current business needs."
      },
      "3":{
        "title":"ERP support and maintenance",
        "desc":"Check your software for security issues and upgrade it for the newest technology to increase your business efficiency. "
      }
    },
    "sec2":"Features for a full power functioning ERP.",
    "sec2Items":{
      "1":{
        "title":"Industry based",
        "desc":"Have exactly what your business needs with no additional features that creates hassle."
      },
      "2":{
        "title":"Embedded analytics",
        "desc":"Easily measure your netripose performance and generate reports to support your strategic planning."
      },
      "3":{
        "title":"Integrations",
        "desc":"Connect your system with your current databases or team collaboration tools for faster and reliable data sync."
      },
      "4":{
        "title":"Mobile first",
        "desc":"Manage your business remotely and track day-to-day operations from your mobile devices."
      },
      "5":{
        "title":"Scalability",
        "desc":"Get a solution that adapts to your current business size and fits with your future growth."
      },
      "6":{
        "title":"Customizations",
        "desc":"Add, remove or adjust features. Whatever your case, we custom a solution that suits your business and matches your brand identity."
      }
    },
    "sec3":"Some of our custom modules.",
    "sec3Items":{
      "1":{
        "title":"CRM",
        "desc":"Improve your customer relationships and help your sales with thorough insights and an updated customer database."
      },
      "2":{
        "title":"PM",
        "desc":"Track projects, chat with clients and connect your team through the whole product development cycle with real time features."
      },
      "3":{
        "title":"HR",
        "desc":"Get your employees to be more productive, schedule tasks and automate monthly performance reports."
      },
      "4":{
        "title":"Supply chain management",
        "desc":"Manage your production lines, control your inventory and link your back office with your front store."
      },
      "5":{
        "title":"Financial",
        "desc":"Use your the system insights to control your operations, balance your costs and do book recordings for your company."
      },
      "5":{
        "title":"Security",
        "desc":"Protect your business and sensitive data through smart authorization features."
      }
    },
    "sec4":"Tailored to the enterprise needs.",
    "sec4Items":{
      "1":{
        "title":"Cost reduction",
        "desc":"Reduce the time, costs and effort needed to run your business and streamline information freely."
      },
      "2":{
        "title":"Centralization",
        "desc":"Gather all your data in one place and analyze it for in depth insights that supports your decision making process."
      },
      "3":{
        "title":"Efficiency",
        "desc":"Automate your manual operations, easily manage workflow and workforce and track the working hours."
      }
    },
    "sec5Items":{
      "1":{
        "title":"Enterprises",
        "desc":"Developing an ERP system that suits your operations scale and helps you connect your business departments for better performance."
      },
      "2":{
        "title":"Startups",
        "desc":"Have a bird eye view on your business operations and optimize your processes for higher performance results."
      }
    },

    "cta":"Organize your business <br> operations."
  },
  "ar": {
    "pageTitle":"أنظمة ادارة الموارد",
    "pageDesc":"نساعدك على إدارة موارد مؤسستك بشكل أكثر ذكاءً باستخدام نظام إدارة الموارد المبني على احتياجات ومتطلبات عملك.",
    "mantra":"نظم أعمالك من خلال |أنظمة ادارة الموارد.",
    "sec1Items":{
      "1":{
        "title":"برمجة نظام ERP",
        "desc":"نساعدك على تصميم حلولك من الصفر بناءً على متطلبات عملك، تغلب على الوحدات اللازمة سواءً لنظام الموارد البشرية أو إدارة المخزون أو غيرها."
      },
      "2":{
        "title":"تخصيصات ERP",
        "desc":"نحلل ونفكر جيدًا في الحل الحالي الذي تعتمد عليه، ثم نقوم بتخصيص المميزات وتحسينها لتناسب احتياجات عملك الحالية بما هو أفضل لك."
      },
      "3":{
        "title":"دعم وصيانة ERP",
        "desc":"نتحقق من النظام لمعرفة مشكلات الأمان ثم نفكر في كيفية تحديثه والاعتماد على آخر التقنيات لزيادة كفاءة عملك."
      }
    },
    "sec2":"تمتع بالمميزات الكاملة لنظام ERP.",
    "sec2Items":{
      "1":{
        "title":"نظام قائم على صناعتك",
        "desc":"احصل على نظام يتناسب مع احتياجات عملك بدون إضافة الكثير من المميزات التي لا فائدة منها حتى لا تضيف متاعب إضافية إليك."
      },
      "2":{
        "title":"إدراج التحليلات",
        "desc":"يمكنك قياس الأداء بسهولة وبدون تعقيدات وإنشاء تقارير حولها من أجل دعم التخطيط الاستراتيجي على أساس هذه التقارير."
      },
      "3":{
        "title":"التكامل",
        "desc":"تستطيع توصيل النظام بقاعدة بياناتك الحالية وكذلك أدوات التعاون الخاصة بالفريق الخاص بك من أجل مزامنة البيانات بشكل أسرع وأكثر موثوقية."
      },
      "4":{
        "title":"الجوال أولًا",
        "desc":"قم بإدارة عملك عن بعد وكذلك تتبع عملياتك اليومية من خلال أجهزة الجوال وبذلك تكون مع فريقك لحظة بلحظة أينما كنت."
      },
      "5":{
        "title":"قابلية التوسع",
        "desc":"احصل على نظام مناسب يتكيف مع وضع عملك الحالي وكذلك يتناسب مع النمو الذي ترغب في الوصول إليه مستقبلًا."
      },
      "6":{
        "title":"التخصيصات",
        "desc":"يمكنك إضافة أو إزالة أو ضبط المميزات التي يحتاجها عملك. مهما كان وضع، نعمل على تخصيص حل مناسب لك تمامًا يتطابق مع أهداف عملك."
      }
    },
    "sec3":"بعض أنظمتنا المخصصة",
    "sec3Items":{
      "1":{
        "title":"إدارة علاقات العملاء CRM",
        "desc":"ارفع من مستوى العلاقات مع عملائك وساعد فرق المبيعات من خلال رؤى ثاقبة وقاعدة بيانات دائمة التحديث حول عملائك."
      },
      "2":{
        "title":"إدارة المشاريع PM",
        "desc":"تتبع مشاريعك لحظة بلحظة وتناقش مع عملائك وفريقك خلال مسار إنتاج المنتجات بأكمله وتمتع بمميزات معرفة التحديثات في وقتها."
      },
      "3":{
        "title":"إدارة الموارد البشرية HR",
        "desc":"ساعد فريقك على أن يكونوا أكثر انتاجية من خلال تحديد جدول المهام وأتمتة تقارير الأداء الشهرية التي تساعدك على تطوير مهاراتهم."
      },
      "4":{
        "title":"إدارة سلسلة التوريد",
        "desc":"قم بإدارة خطوط الانتاج الخاصة بك، وسيطر على المخزون الذي تمتلكه وقم بالربط بين مخازن التوزيع والمتاجر."
      },
      "5":{
        "title":"الأمور المالية",
        "desc":"استخدم معلومات النظام الخاص بك من أجل التحكم في عمليات المختلفة واعمل على تحقيق التوازن بين تكاليفك وقم بتسجيل بيانات شركتك."
      },
      "5":{
        "title":"الأمان",
        "desc":"اعمل على حماية أعمالك وبياناتك الحساسة والخطيرة من خلال مميزات التحقق التي تمنحك أعمالك الآمان والحماية."
      }
    },
    "sec4":"مصممة لاحتياجات مؤسستك.",
    "sec4Items":{
      "1":{
        "title":"تقليل التكاليف",
        "desc":"قلل الجهد والتكاليف والوقت الذي تستهلكهم في إدارة أعمالك، وكذلك قم بالتبسيط بين معلومات أعمالك بكفاءة."
      },
      "2":{
        "title":"المركزية",
        "desc":"جمع كل بياناتك في مكان واحد واحصل على تقارير و رؤى متعمقة تساعدك في عمليات اتخاذ القرار ."
      },
      "3":{
        "title":"الكفاءة",
        "desc":"اعتمد على الآلية في جميع العمليات اليدوية، وقم بإدارة سير العمل وتتبع العمليات التي تتم وكذلك ساعات العمل."
      }
    },
    "sec5Items":{
      "1":{
        "title":"الشركات",
        "desc":"طور نظام تخطيط موارد المؤسسة الذي يتناسب مع نطاق عملياتك ويساعدك على ريادة أعمالك بالصورة التي تحلم بها."
      },
      "2":{
        "title":"الشركات الناشئة",
        "desc":"احصل على رؤية جذابة حول عملك وفكر في كيفية تحسينه وتطويره من أجل الحصول على نتائج أعلى وأكثر فاعلية."
      }
    },

    "cta":"رتب أداء عملك الآن!"
  }
}
</i18n>
